import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import listaGanadoresPdf from '../../assets/files/Premio/GANADORES PREMIO EM Y EXC ACAD. 2024.pdf'

const ModalRJCE = ({ toggleFunction, modalState }) => {

  const titulo = 'PREMIO DR. ENRIQUE MOLINA Y PREMIO A LA EXCELENCIA COHORTE 2024'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-justify premio-dem'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner mb-4' /> */}

          <h3 className='modal-subtitle continuous spaced-lg fs-base lh-base text-center'>{titulo}</h3>

          <p className='heading-p'>Desde la División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia, les extendemos una cordial invitación al acto de reconocimiento donde se otorgará, en primer lugar, el <b>Premio Doctor Enrique Molina</b>, y <b>Reconocimiento a la Excelencia Académica</b>  Cohorte 2024. </p>

          <div className='info-group'>

            <p className='spaced-lg'>Este acto será el día jueves 20 de noviembre en el Teatro Niños Cantores del Zulia a las 8:30 de la mañana.
            </p>
            
            <p className='spaced-lg'>Asistir con traje formal.</p>

            <p className='spaced-lg'>Cada homenajeado puede llevar un acompañante y les solicitamos llegar 1 Hora antes (7:30 AM) para la verificación en la lista protocolar.</p>
            
            <p className='spaced-lg'>Este reconocimiento honra a quienes han obtenido un puntaje de 19 o más puntos. </p>

            <p className='mb-2'>Agradecemos su puntualidad y presencia para celebrar juntos este logro.</p>
            
            
          </div>


          <div className='info-group'>
            <div className='d-flex flex-column justify-content-center text-center'>
              <span className='fw-bold'>Dr. Freddy Pachano Arenas</span>
              <span className='fw-normal mb-4'>Director</span>

              <span className='fw-bold'>Dra. Vanessa Belloso</span>
              <span className='fw-normal'>Secretaria Docente</span>
            </div>

          </div>

          <div className='d-flex justify-content-center mb-3'>
            <Button
              as='a'
              href={listaGanadoresPdf}
              target='blank'
              className='link-button rounded-pill'
            >
              Lista de Ganadores
            </Button>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalRJCE }